<div class="report-model">


  <app-datatable-title [title]="'reports.unitRental'" [count]="unitRentalCount" [countTitle]="'reports.totalUnits'"></app-datatable-title>

  <app-report-datatable
   class="default-table-view"
      [showLoader]="!unitRentalLoading"
      [tableColumns]="unitRentalPropertyColumns"
      [dataLength]="unitRentalCount"
      [tableData]="unitRentalData"
      [allowExcelDownload]="true"
      (pageEvent)="onPageEvent($event)"
      (sort)="sortData($event)"
      (excelDownload)="downloadExcel($event, 'property_detail_office_unit_rental')"
      [downloadLoading]="downloadLoading" [showEstaterText]="true"
      [reportSectionTitle]="'Unit Rental'">
  </app-report-datatable>
</div>
